const Items = [
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-1',
        theme: 'El Amor',
        ref: 'Juan 13:34,35',
        text: {
            lbla: 'Un mandamiento nuevo os doy: que os améis los unos a los otros; que como yo os he amado, así también os améis los unos a los otros. En esto conocerán todos que sois mis discípulos, si os tenéis amor los unos a los otros.'
        }
    },
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-2',
        theme: 'El Amor',
        ref: '1 Juan 3:18',
        text: {
            lbla: 'Hijos, no amemos de palabra ni de lengua, sino de hecho y en verdad.'
        }
    },
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-3',
        theme: 'La Humildad',
        ref: 'Filipenses 2:3,4',
        text: {
            lbla: 'Nada hagáis por egoísmo o por vanagloria, sino que con actitud humilde cada uno de vosotros considere al otro como más importante que a sí mismo, no buscando cada uno sus propios intereses, sino más bien los intereses de los demás.'
        }
    },
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-4',
        theme: 'La Humildad',
        ref: '1 Pedro 5:5,6',
        text: {
            lbla: 'Asimismo, vosotros los más jóvenes, estad sujetos a los mayores; y todos, revestíos de humildad en vuestro trato mutuo, porque Dios resiste a los soberbios, pero da gracia a los humildes.'
        }
    },
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-5',
        theme: 'La Pureza',
        ref: 'Efesios 5:3',
        text: {
            lbla: 'Pero que la inmoralidad, y toda impureza o avaricia, ni siquiera se mencionen entre vosotros, como corresponde a los santos;'
        }
    },
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-6',
        theme: 'La Pureza',
        ref: '1 Pedro 2:11',
        text: {
            lbla: 'Amados, os ruego como a extranjeros y peregrinos, que os abstengáis de las pasiones carnales que combaten contra el alma.'
        }
    },
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-7',
        theme: 'La Honestidad',
        ref: 'Levítico 19:11',
        text: {
            lbla: 'No hurtaréis, ni engañaréis, ni os mentiréis unos a otros.'
        }
    },
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-8',
        theme: 'La Honestidad',
        ref: 'Hechos 24:16',
        text: {
            lbla: 'Por esto, yo también me esfuerzo por conservar siempre una conciencia irreprensible delante de Dios y delante de los hombres.'
        }
    },
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-9',
        theme: 'La Fe',
        ref: 'Hebreos 11:6',
        text: {
            lbla: 'Y sin fe es imposible agradar a Dios; porque es necesario que el que se acerca a Dios crea que Él existe, y que es remunerador de los que le buscan.'
        }
    },
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-10',
        theme: 'La Fe',
        ref: 'Romanos 4:20,21',
        text: {
            lbla: 'sin embargo, respecto a la promesa de Dios, Abraham no titubeó con incredulidad, sino que se fortaleció en fe, dando gloria a Dios, y estando plenamente convencido de que lo que Dios había prometido, poderoso era también para cumplirlo.'
        }
    },
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-11',
        theme: 'Las Buenas Obras',
        ref: 'Gálatas 6:9,10',
        text: {
            lbla: 'Y no nos cansemos de hacer el bien, pues a su tiempo, si no nos cansamos, segaremos. Así que entonces, hagamos bien a todos según tengamos oportunidad, y especialmente a los de la familia de la fe.'
        }
    },
    {
        groupClass: 'is-warning',
        group: 'Crecer en Semejanza a Cristo',
        number: 'E-12',
        theme: 'Las Buenas Obras',
        ref: 'Mateo 5:16',
        text: {
            lbla: 'Así brille vuestra luz delante de los hombres, para que vean vuestras buenas acciones y glorifiquen a vuestro Padre que está en los cielos.'
        }
    }
];

export default Items;
